// extracted by mini-css-extract-plugin
module.exports = {"AlbumSongs":"AlbumSongs_AlbumSongs__33Slp","PageNavigation":"AlbumSongs_PageNavigation__33BXn","Prev":"AlbumSongs_Prev__3qcfQ","Next":"AlbumSongs_Next__MRXy2"};